module.exports = __webpack_public_path__ + "static/media/90300-Inox.96c22a03.png";